import { registerStep } from "./stepsRegistry";
import type { StepDefinition } from "./types";
import { AccionistasStep } from "@/components/form-steps/AccionistasStep";
import { accionistasStepSchema } from "@/schemas/multistep/accionistas.schema";

const definition: StepDefinition = {
  id: "accionistas",
  title: "Accionistas con participación superior al 5%",
  schema: accionistasStepSchema,
  Component: AccionistasStep,
  isApplicable: (tipoDocumento: string = ""): boolean => {
    return tipoDocumento === "NIT";
  },
  // isApplicable: () => true,
};

registerStep(definition);
